require('./bootstrap');
require('./alpine');
require('./motion-one');
require('./lottie');
require('./swiper');
require('./forms');
require('./cookie-consent.js');

//Product Image Viewer

document.addEventListener('DOMContentLoaded', () => {
    const productImages = document.querySelectorAll('.product-image');
    const activeProductImage = document.getElementById('active-product-image');

    const updateImageViewer = (event) => {
        activeProductImage.src = event.target.src;
        activeProductImage.alt = event.target.alt;
    };

    productImages.forEach((image) => {
        image.addEventListener('click', (event) => {
            updateImageViewer(event);
        });
    });
});
